import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import { authOperations } from './../../../reducks/auth';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import config from './../../../config/config.js';

const styles = theme => ({
  root: {
    display: 'flex',
  },
});

class TimeCheck extends React.Component {

  state = {
    timeout: false,
    checktime: config.TIMEOUT_SECOND,
  };
  
  componentDidMount = () => {
    if(0 < config.TIMEOUT_SECOND){
      this.timer = setInterval(this.doCheckTime, 5000);
    }
  };
  
  doCheckTime = () => {
    if(this.props.isAuthenticated){
        //UTC変換した現時刻と保持している時刻の差（ms）を計測
        let diffTime = (new Date(Date.now() + new Date().getTimezoneOffset() * 60000)).getTime() - this.props.checkAccess.time;
        if(diffTime / 1000 > this.state.checktime){
          this.setState({timeout:true});
        }
    }
  };

  doLogout = () => {
    this.setState({timeout: false});
    this.props.logoutOperation();
  };
  
  render() {
    const { classes } = this.props;
    const value = this.state.checktime;
    
    return (
      <div>
        {this.state.timeout &&
        <div>
          <Dialog
            open={true}
            onClose={this.handleClose}
            disableBackdropClick={true}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <DialogContentText className={classes.dialogcontext}>
                <FormattedMessage id="TimeCheck.err.timeout" values={{value}} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.doLogout} color="primary">
                <FormattedMessage id={'TimeCheck.btn.close'}/>
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        }
      </div>
    );
  }
}

TimeCheck.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  checkAccess: state.common.checkAccess,
  theme: state.style.theme,
});

const mapDispatchToProps = {
  logoutOperation: authOperations.logoutOperation,
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(TimeCheck))
);
